import { Link } from "react-router-dom";
import { useTranslate } from "../hooks/LanguageProvider";

export default function AccessDenied() {
  const { translate } = useTranslate();

  return (
    <main
      className="d-flex align-items-center justify-content-center bg-light"
      style={{ minHeight: "100vh", padding: "24px" }}
    >
      <section
        className="card border-0 shadow-sm text-center"
        style={{ maxWidth: "560px", width: "100%" }}
      >
        <div className="card-body p-5">
          <div
            className="d-inline-flex align-items-center justify-content-center rounded-circle mb-4"
            style={{ width: 72, height: 72, background: "#fff3cd" }}
            aria-hidden="true"
          >
            <i className="las la-lock" style={{ fontSize: 38, color: "#856404" }} />
          </div>
          <h1 className="h3 mb-3">{translate("Access denied")}</h1>
          <p className="text-muted mb-4">
            {translate(
              "You do not have permission to view this page. Please contact the administrator.",
            )}
          </p>
          <Link className="btn btn-warning px-4" to="/">
            {translate("Back to dashboard")}
          </Link>
        </div>
      </section>
    </main>
  );
}
